"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ROUTER = exports.ROUTER = void 0;
const types_1 = require("../types");
exports.ROUTER = {
    [types_1.Networks.Ropsten]: {
        [types_1.Factory.V2V1]: '0xbFf4acF789297A8507Eb7493AE18EB2C3A3A9632' // OLD ROUTER
    },
    [types_1.Networks.Mainnet]: {
        [types_1.Factory.V2V1]: '0x6271c6D2Cf5072D769A16eD99C8D5F3272d44E4F'
    },
    [types_1.Networks.Polygon]: {
        [types_1.Factory.V2V1_1]: '0x69767394c72240275A7a6CCeD1f1a7960Aa06333',
        [types_1.Factory.V2V2]: '0xF117a35038cdcfFAAeA6f953438E048D9440A9c2',
        [types_1.Factory.SOLV2]: '0xD7F63a4F2d317b51e84e64cb0d1eDB9F70956Ac9',
        [types_1.Factory.SOL_STABLE]: '0xe564D3d09863D81ACa176abE58de027389a186aA',
    },
    [types_1.Networks.Arbitrum]: {
        [types_1.Factory.V2V1_1]: '0x9655C5a1ADB30EC5a3a7AD5d06AbeDe8468B60B7',
        [types_1.Factory.V2V2]: '0x58d966725Ee8fcd93CAF7C98C0c8F9b34ef076D3',
        [types_1.Factory.SOLV2]: '0x3b03681d1a46B473F0074cd2C4D27f086497DD56',
    },
    [types_1.Networks.Avalanche]: {
        [types_1.Factory.V2V1_2]: '0xA8567d1229cCaB63E3a834Cd29066a063911E4cf',
        [types_1.Factory.V2V2]: '0xfB48b69fcba9218f86a437121198E46b2b88Ad63',
        [types_1.Factory.SOLV2]: '0xD18d2B8BaAd0078593a3C020cc3c6c5CD2F5B8b8',
    },
    [types_1.Networks.Moonriver]: {
        [types_1.Factory.V2V1_2]: '0x3271cc175577465691e48196955e09d638fa05d5', // OLD ROUTER
    },
    [types_1.Networks.Aurora]: {
        [types_1.Factory.V2V1_2]: '0xBB92270716C8c424849F17cCc12F4F24AD4064D6', // OLD ROUTER
    },
    [types_1.Networks.Cronos]: {},
    [types_1.Networks.Fantom]: {
        [types_1.Factory.SOLV1_2]: '0xF655C8567E0f213e6C634CD2A68d992152161dC6',
        [types_1.Factory.SOLV2]: '0xd9eA4A62C46Cb221F74314C21979Cfb2E020de87',
        [types_1.Factory.V2V2]: '0xd4B557536c7d30463b9BEB470c117F8963Cee24a'
    },
    [types_1.Networks.Canto]: {
        [types_1.Factory.SOLV2]: '0x370D3eE40f1257fC432C33e387981CeDD15C7fac',
    },
    [types_1.Networks.ZksyncEra]: {
        [types_1.Factory.SOLV2]: '0xDC9eb03D753D552A3eE286d272F37d49de2783D3',
    },
    [types_1.Networks.Blast]: {
        [types_1.Factory.SOLV2]: '0x447b4E5C469b76A1f7175cE7b224629091713a02',
        [types_1.Factory.V2V2]: '0x57f9284e10cA2e21181FA626973C72D45a45fd20',
        [types_1.Factory.SOL_STABLE]: '0xd02Db94aAb460703B2a0A6928eA720B9009Da3D1',
    },
    [types_1.Networks.Harmony]: {},
    [types_1.Networks.Moonbeam]: {},
    [types_1.Networks.Sxnetwork]: {},
    [types_1.Networks.Base]: {
        [types_1.Factory.SOLV2]: '0x1EBC3b5911B99aDdE07944c75D9E03958abdB49f',
        [types_1.Factory.SOL_STABLE]: '0xC5d6CB2205349Cc94684E7acF012751344bc58F7',
        [types_1.Factory.V2V2]: '0x21D9d4d17255d427A5F77D23fb9Eb3c5Cd281ebf'
    },
    [types_1.Networks.Scroll]: {
        [types_1.Factory.SOLV2]: '0xFF8D0CDC9C857c7fA265121394558B26e1eAAffE',
        [types_1.Factory.SOL_STABLE]: '0x736176788edef99D2FAbfAa0f5e13BCb3b46bE17'
    },
    [types_1.Networks.Optimism]: {
        [types_1.Factory.SOLV2]: '0xb5657FA5ba87CaD11b9150c319069625d423aaD4',
    },
    [types_1.Networks.Mantle]: {
        [types_1.Factory.V2V2]: '0xF4A9dda025e65945E7A3F873D6146A12c8110A19'
    },
    [types_1.Networks.Real]: {
        [types_1.Factory.SOLV2]: '0x64515b2f866Ac9B1297f03329d82a8507332fEf5',
        [types_1.Factory.SOL_STABLE]: '0x3784D354863fe8862d60E446E3f29A08c21D1Ea9'
    },
    [types_1.Networks.Sonic]: {
        [types_1.Factory.SOLV2]: '0xcBdf792456367a91708C0036E0678eCFB1f09654',
        [types_1.Factory.SOL_STABLE]: '0xac72B40A14375C4B11Fa469a0616aF9bb2Cc87C8',
    },
    [types_1.Networks.Linea]: {
        [types_1.Factory.SOLV2]: '0xEB81da0cAC9D3efc4bf3270080936C6a5758926f',
        [types_1.Factory.SOL_STABLE]: '0xC8BBC42B546d25c411b9BD42cDDDa12c00B468bc',
    },
};
exports.DEFAULT_ROUTER = {
    [types_1.Networks.Ropsten]: '0xbFf4acF789297A8507Eb7493AE18EB2C3A3A9632',
    [types_1.Networks.Mainnet]: '0x6271c6D2Cf5072D769A16eD99C8D5F3272d44E4F',
    [types_1.Networks.Polygon]: '0xF117a35038cdcfFAAeA6f953438E048D9440A9c2',
    [types_1.Networks.Arbitrum]: '0x58d966725Ee8fcd93CAF7C98C0c8F9b34ef076D3',
    [types_1.Networks.Avalanche]: '0xfB48b69fcba9218f86a437121198E46b2b88Ad63',
    [types_1.Networks.Moonriver]: '0x3271cc175577465691e48196955e09d638fa05d5',
    [types_1.Networks.Aurora]: '0xBB92270716C8c424849F17cCc12F4F24AD4064D6',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: '0xF655C8567E0f213e6C634CD2A68d992152161dC6',
    [types_1.Networks.Canto]: '0x370D3eE40f1257fC432C33e387981CeDD15C7fac',
    [types_1.Networks.ZksyncEra]: '0xDC9eb03D753D552A3eE286d272F37d49de2783D3',
    [types_1.Networks.Blast]: '0x447b4E5C469b76A1f7175cE7b224629091713a02',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Base]: '0x1EBC3b5911B99aDdE07944c75D9E03958abdB49f',
    [types_1.Networks.Scroll]: '0xFF8D0CDC9C857c7fA265121394558B26e1eAAffE',
    [types_1.Networks.Real]: '0x3784D354863fe8862d60E446E3f29A08c21D1Ea9',
    [types_1.Networks.Mantle]: '0xF4A9dda025e65945E7A3F873D6146A12c8110A19',
    [types_1.Networks.Optimism]: '0xb5657FA5ba87CaD11b9150c319069625d423aaD4',
    [types_1.Networks.Sonic]: '0xcBdf792456367a91708C0036E0678eCFB1f09654',
    [types_1.Networks.Linea]: '0xEB81da0cAC9D3efc4bf3270080936C6a5758926f',
};
